export const buildProvenance = { "commitHash": "1b1669fb4e9e8feec349e65328eacea4f6fdeb62", "branchName": "refs/heads/release/2025.1", "buildDate": "2025-03-13T01:40:40.293Z", "version": "2025.1.9954" };
